import { IExternalLinkForm, IExternalLinkModel } from '@api/models';
import { addExternalLink } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface AddExternalLinkOptions {
    clientId: string;
    onAdd: (externalLink: IExternalLinkModel) => void;
}

const useAddExternalLinkForm = (options: AddExternalLinkOptions) => {
    const { clientId, onAdd } = options;

    const initialValues: IExternalLinkForm = {
        path: '',
        name: '',
        users: [],
        folderId: null,
    };

    const addExternalLinkMutation = useMutation((values: { payload: IExternalLinkForm }) => {
        const { payload } = values;

        return addExternalLink(clientId, payload);
    });

    const submit = async (values: IExternalLinkForm) => {
        try {
            const newFile = await addExternalLinkMutation.mutateAsync({
                payload: values,
            });

            onAdd(newFile);
        } catch (err: any) {
            if (err?.message !== 'canceled') {
                throw new Error(err);
            }
        }
    };

    return {
        isLoading: addExternalLinkMutation.isLoading,
        initialValues,
        submit,
    };
};

export default useAddExternalLinkForm;
